import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { Button, Form, Input, Divider, Alert } from "antd";
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { GoogleSVG, FacebookSVG } from 'assets/svg/icon';
import CustomIcon from 'components/util-components/CustomIcon'
import {  
	showLoading, 
	showAuthMessage, 
	hideAuthMessage,
	authenticated
} from 'redux/actions/Auth';
import JwtAuthService from 'services/JwtAuthService'
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion"

export const LoginForm = (props) => {
	let history = useHistory();

	const { 
		otherSignIn, 
		showForgetPassword, 
		hideAuthMessage,
		onForgetPasswordClick,
		showLoading,
		extra,
		loading,
		showMessage,
		message,
		authenticated,
		showAuthMessage,
		token,
		redirect,
		allowRedirect
	} = props

	const onLogin = values => {
		showLoading()
		JwtAuthService.login(values).then(resp => {
			//console.log('resssppp', resp)
			if(!resp.status){
				showAuthMessage(resp?.mensagem)
			}else{
				localStorage.setItem('auth_token', resp?.token);
				localStorage.setItem('auth_data', JSON.stringify(resp?.user_data));
				authenticated(resp?.token)
			}
		}).then(e => {
			//showAuthMessage(e)
		})
	};

	const onGoogleLogin = () => {
		showLoading()
	}

	const onFacebookLogin = () => {
		showLoading()
	}

	useEffect(() => {
		if (token !== null && allowRedirect) {
			history.push(redirect)
		}
		if(showMessage) {
			setTimeout(() => {
			hideAuthMessage();
		}, 3000);
		}
	});
	
	const renderOtherSignIn = (
		<div>
			<Divider>
				<span className="text-muted font-size-base font-weight-normal">or connect with</span>
			</Divider>
			<div className="d-flex justify-content-center">
				<Button 
					onClick={() => onGoogleLogin()} 
					className="mr-2" 
					disabled={loading} 
					icon={<CustomIcon svg={GoogleSVG}/>}
				>
					Google
				</Button>
				<Button 
					onClick={() => onFacebookLogin()} 
					icon={<CustomIcon svg={FacebookSVG}/>}
					disabled={loading} 
				>
					Facebook
				</Button>
			</div>
		</div>
	)

	return (
		<>
			<motion.div 
				initial={{ opacity: 0, marginBottom: 0 }} 
				animate={{ 
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0 
				}}> 
				<Alert type="error" showIcon message={message ? message : `Falha ao logar, confirme seus dados.`}></Alert>
			</motion.div>
			<Form 
				layout="vertical" 
				name="login-form"
				onFinish={onLogin}
			>
				<Form.Item 
					name="email"
					rules={[
						{ 
							required: true,
							message: 'Informe o seu email',
						},
						{ 
							type: 'email',
							message: 'Informe um email válido!'
						}
					]}>
					<Input placeholder="E-mail" prefix={<MailOutlined className="text-dark" />}/>
				</Form.Item>
				<Form.Item 
					name="password"
					className="mb-3 pb-0"
					/*label={
						<div className={`${showForgetPassword? 'd-flex justify-content-between w-100 align-items-center' : ''}`}>
							<span>Senha</span>
							{
								showForgetPassword && 
								<span 
									onClick={() => history.push(`/auth/forgot-password`)} 
									className="cursor-pointer font-size-sm font-weight-normal text-muted d-inline-block" style={{ float: 'right' }}
								>
									Esqueceu a Senha ?
								</span>
							} 
						</div>
					}*/
					rules={[
						{ 
							required: true,
							message: 'Informe sua senha de acesso',
						}
					]}
				>
					<Input.Password placeholder="Senha" prefix={<LockOutlined className="text-dark" />}/>
				</Form.Item>
				<div className={`${showForgetPassword? 'd-flex justify-content-between w-100 align-items-center' : ''}`}>
					{
						showForgetPassword && 
						<span 
							onClick={() => history.push(`/auth/forgot-password`)} 
							className="cursor-pointer text-muted d-inline-block pb-3" style={{ fontSize: '13px', fontWeight: 500 }}
						>
							Esqueceu a Senha ?
						</span>
					}
					<a href="/auth/register" className="cursor-pointer text-muted d-inline-block pb-3" style={{ fontSize: '13px', fontWeight: 500 }}>Criar Conta</a>
				</div>
				<Form.Item>
					<Button type="primary" htmlType="submit" block className="py-3 h-auto" loading={loading} style={{ fontSize: '15px', fontWeight: 700 }}>
						Entrar
					</Button>
				</Form.Item>
				{/*<div>
					<Divider>
						<span className="text-muted font-size-base font-weight-normal py-0">Não Possui Uma Conta ?</span>
					</Divider>
					<div className="d-flex justify-content-center py-0 my-0">
						<a href="/auth/register">Criar Conta</a>
					</div>
				</div>*/}
				{ extra }
			</Form>
		</>
	)
}

LoginForm.propTypes = {
	otherSignIn: PropTypes.bool,
	showForgetPassword: PropTypes.bool,
	extra: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
};

LoginForm.defaultProps = {
	otherSignIn: false,
	showForgetPassword: true
};

const mapStateToProps = ({auth}) => {
	const {loading, message, showMessage, token, redirect} = auth;
  	return {loading, message, showMessage, token, redirect}
}

const mapDispatchToProps = {
	showAuthMessage,
	showLoading,
	hideAuthMessage,
	authenticated
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
